import React, { createContext, useContext, ReactNode, useState } from 'react';

interface PageHeaderContextType {
  setHeader: (header: ReactNode) => void;
  header: ReactNode;
}

const PageHeaderContext = createContext<PageHeaderContextType>({
  setHeader: () => {},
  header: null
});

export const usePageHeader = () => useContext(PageHeaderContext);

export const PageHeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [header, setHeader] = useState<ReactNode>(null);

  return (
    <PageHeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export default PageHeaderContext; 